export default __webpack_public_path__ + "static/media/sports (2).87a917af.jpg";